import { COLORS, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import { LayoutSidebar, Menu } from '@/ui';
import styled from 'styled-components';

export const StyledLogoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 2.4rem;
  margin: 1rem auto;
  display: flex;
  justify-content: center;
`;

export const StyledCollapseWrapper = styled.div<{ $isCollapsed: boolean }>`
  position: absolute;
  right: -1rem;
  cursor: pointer;
  transform: ${({ $isCollapsed }) => `rotate(${$isCollapsed ? '180deg' : '0'})`};
`;

export const StyledDesktopSider = styled(LayoutSidebar)`
  position: relative;
  & .ant-layout-sider-children {
    position: sticky;
    top: 0;
    border-right: 1px solid #dcdcdc;
    height: 100vh;
    background: ${COLORS.WHITE};
  }
`;

export const StyledDesktopSideBarMenu = styled(Menu)<{ $isCollapsed: boolean }>`
  &.ant-menu.ant-menu-vertical {
    margin: 0 0.5rem;
    background: ${COLORS.WHITE};
    border: none;

    &&& li {
      background-color: inherit;
      .ant-menu-item-icon {
        min-width: 1.5rem;
        min-height: 1rem;
      }
    }

    &.ant-menu {
      display: flex;
      flex-direction: column;
    }

    &&& .ant-menu-item-selected {
      color: ${COLORS.ORANGE_PRIMARY};
      background-color: ${COLORS.ORANGE_PRIMARY}1A;

      path {
        fill: ${COLORS.ORANGE_PRIMARY};
      }
    }

    & .ant-menu-item-divider {
      ${({ $isCollapsed }) => {
        return $isCollapsed ? `width: 70%;` : `width: 90%;`;
      }}
      border: none;
      border-top: 1px solid ${COLORS.GREY};
    }

    & .ant-menu-item {
      ${pickThemeFontStyles('14', '24', 'NORMAL')};
      display: flex;
      align-items: center;
      color: ${COLORS.BLACK};
      ${({ $isCollapsed }) => {
        return $isCollapsed ? `width: 3.5rem;` : `padding-inline: 0.5rem;`;
      }}

      &&& a {
        color: ${COLORS.GREY};
      }
      
      & path {
        fill: ${COLORS.GREY};
      }

      & .anticon {
        font-size: ${pickThemeFontSize('24')};
    }

    .ant-menu-item-selected {
      ${pickThemeFontStyles('14', '24', 'SEMI_BOLD')};
    }

    & .ant-menu-item.ant-menu-item-active {
      color: ${COLORS.BLACK};
    }
  }
`;

export const StyledMenu = styled.div`
  max-height: calc(100vh - 9rem);
  height: 100%;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
